import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
import {
    clear_vehicle,
    getAllVehicle,
    getItemVehicle,
    UPDATE_VEHICLE,
    updateVehicle
} from "../../../redux/vehicles";
import CheckBox from "../../../components/check-box";
import {URLAPI} from "../../../config";
import {getAllEmployeesVehicle} from "../../../redux/employees";
import Select from "react-select";
import {
    clear_employee_vehicle,
    CREATE_EMPLOYEE_VEHICLE,
    createEmployeeVehicle,
} from "../../../redux/employee_vehicle";

const UpdateVehicle = (props) => {
    let history = useHistory();
    const {id} = useParams();

    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const _update_vehicle = useSelector((state) => state.vehicle_module._update_vehicle);
    const _create_employee_vehicle = useSelector((state) => state.employee_vehicle_module._create_employee_vehicle);
    const _get_all_employees_vehicle = useSelector(state => state.employees_module._get_all_employees_vehicle);

    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [id_employee, setIdEmployee] = useState(0);
    const [employees, setEmployees] = useState([]);
    const [employeeSelected, setEmployeeSelected] = useState([]);
    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    const [form, setForm] = useState({
        placa: "",
        marca: "",
        modelo: "",
        color: "",
        anio: "",
        kilomatraje_actual: "",
        activo: true,
        empleados: [],
        iamgen: ''
    });


    useEffect(() => {
        // eslint-disable-next-line
        searchItemVehicle();
        // eslint-disable-next-line
    }, [token, id]);


    async function searchItemVehicle() {
        setIsLoading(true);
        try {
            const response = await getItemVehicle(token, id);
            if (response && response.data && response.data.datos) {
                setForm(response.data.datos[0])
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        let array = [];
        if (_get_all_employees_vehicle && _get_all_employees_vehicle.data && _get_all_employees_vehicle.data.datos) {
            array = _get_all_employees_vehicle.data.datos.map(element => {
                return {
                    value: element.id,
                    label: element.nombres + " " + element.apellidos,
                }
            })
            setEmployees(array)
        }
    }, [_get_all_employees_vehicle])

    const handleChange = (e) => {
        if (e.target.name === 'activo') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        setImagePreview(url);
        setForm({
            ...form,
            [e.target.name]: e.target.files[0],
        });
    };

    useEffect(() => {
        if (_update_vehicle.status === 200) {
            dispatch(clear_vehicle(UPDATE_VEHICLE));
            dispatch(getAllVehicle(token));
            setIsLoading(false);
            history.push("/vehiculos");
        } else {
            if (_update_vehicle.status !== 0) {
                toast.error(_update_vehicle.message);
                setIsLoading(false);
            }
        }
    }, [_update_vehicle, dispatch, history, token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        if (form.placa === "") {
            toast.error("Debe ingresar la placa", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.marca === "") {
            toast.error("Debe ingresar la marca", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.modelo === "") {
            toast.error("Debe ingresar el modelo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.color === "") {
            toast.error("Debe ingresar el color", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.anio === "") {
            toast.error("Debe ingresar el año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_actual === "") {
            toast.error("Debe ingresar el kilometraje actual", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(updateVehicle(token, id, form));
    };

    useEffect(() => {
        if (_create_employee_vehicle.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_employee_vehicle(CREATE_EMPLOYEE_VEHICLE));
            searchItemVehicle();
            setIsLoading(false);
            setModal(false);
        } else if (_create_employee_vehicle.status !== 0) {
            dispatch(clear_employee_vehicle(CREATE_EMPLOYEE_VEHICLE));
            toast.error(_create_employee_vehicle.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_employee_vehicle, dispatch, history, token, id]);

    const handleChangeEmployee = (e) => {
        setIdEmployee(parseInt(e.value));
        setEmployeeSelected(e);
    }

    const handleSubmitEmployee = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (id_employee === 0) {
            toast.error("Debe seleccionar un empleado", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createEmployeeVehicle(token, {"id_vehiculo": id, "id_empleado": id_employee}));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div><ToastContainer/></div>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Vehículos", link: "/vehiculos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Vehículo</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                name="placa"
                                                label="Placa"
                                                value={form.placa}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="marca"
                                                label="Marca"
                                                value={form.marca}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="modelo"
                                                label="Modelo"
                                                value={form.modelo}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="color"
                                                label="Color"
                                                value={form.color}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="anio"
                                                label="Año"
                                                value={form.anio}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="kilometraje_actual"
                                                label="Kilomatraje actual"
                                                value={form.kilometraje_actual}
                                                onChange={handleChange}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                name="imagen"
                                                label="Imagen"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <img
                                                src={
                                                    imagePreview == null
                                                        ? `${URLAPI}${form.foto}`
                                                        : imagePreview
                                                }
                                                alt="imagen"
                                                width={60}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                                      state={form.activo}/>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6 col-12">
                                            <h5>Empleados Asignados</h5>
                                        </div>
                                        {(permisos.filter(x => x.codigo === 'add_vehicles').length > 0 || permisos.filter(x => x.codigo === 'change_vehicles').length > 0) &&
                                            <div className="col-md-6 col-12 text-right">
                                                <Button type="button" text="Agregar empleado" theme="secondary" classes="mb-1"
                                                        onChange={() => {
                                                            dispatch(getAllEmployeesVehicle(token));
                                                            setIdEmployee(0);
                                                            setEmployeeSelected([]);
                                                            setModal(true);
                                                        }}/>
                                            </div>
                                        }
                                        {(form.empleados && form.empleados.length > 0) &&
                                            <div className="col-12" style={{padding: "0 2em"}}>
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center">Fecha de asignación</th>
                                                                <th className="text-center">Empleado</th>
                                                                <th className="text-center">Cargo</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {form.empleados.map((g) =>
                                                            <tr>
                                                                <td>{g.fecha}</td>
                                                                <td>{g.empleado}</td>
                                                                <td>{g.cargo}</td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="card-footer d-flex justify-content-end">
                                        <Link to="/vehiculos" className="btn btn-danger m-1">
                                            Cancelar
                                        </Link>
                                        {(permisos.filter(x => x.codigo === 'change_vehicles').length > 0) &&
                                            <Button
                                                type="submit"
                                                text={<><i className="bx bx-save"/> Guardar</>}
                                                theme="success"
                                                disabled={isLoading}
                                            />
                                        }
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmitEmployee}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Agregar empleado</h5>
                        <div className="form-group">
                            <label className="form-label">Empleado</label>
                            <Select
                                options={employees}
                                isMulti={false}
                                onChange={handleChangeEmployee}
                                value={employeeSelected}
                            />
                        </div>
                    </div>
                    <div className="text-center">
                        <button type="button" className="btn btn-outline-dark" onClick={() => {
                            setModal(false);
                        }}> Cancelar
                        </button>
                        <Button type="submit" text="Guardar" theme="success" classes="m-1"/>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default UpdateVehicle;
